import { getDashboardDetails } from "../../../api/dashboard";
import { useQuery } from "./helper";
import { TResponseItemWrapper } from "../../types/common";
import { Dashboard } from "../../types/dashboard";

export const useDashboard = (options) => useQuery<TResponseItemWrapper<Dashboard>>({
    queryKey: ['dashboard'],
    queryFn: () => getDashboardDetails(),
    ...options,
});
